import request from '../request';

const AUTH_CLIENT_AUTHORIZATION = 'Basic enMtY21zOjEyMzQ1Ng==';
export const AUTH_CLIENT_ID = 'zs-cms';

export type PasswordLoginParams = Record<string, string>;

function toFormBody(params: PasswordLoginParams) {
  return Object.keys(params)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
}

const authApi = {
  // 校验token
  checkToken(params: any) {
    return request.post('/auth/oauth/check_token', null, {
      params,
      headers: { Authorization: AUTH_CLIENT_AUTHORIZATION },
    });
  },
  // 登录请求
  login(params: any) {
    return request.post('/auth/oauth/token', null, {
      params,
      headers: { Authorization: AUTH_CLIENT_AUTHORIZATION },
      isNotToken: true,
    });
  },
  // 查询当前客户端是否开启密码登录短信二次认证
  getLoginChallengeEnabled() {
    return request.get('/auth/sms/password-login-verification', {
      params: { clientId: AUTH_CLIENT_ID },
      isNotToken: true,
      skip401Redirect: true,
    });
  },
  // 查询账号密码登录的加密开关和 RSA 公钥
  getLoginEncryptionPublicKey() {
    return request.get('/auth/login-encryption/public-key', {
      params: { clientId: AUTH_CLIENT_ID },
      isNotToken: true,
      skip401Redirect: true,
    });
  },
  // 账号密码登录统一使用表单正文，避免敏感参数出现在 URL 中
  passwordLogin(params: PasswordLoginParams) {
    return request.post('/auth/oauth/token', toFormBody(params), {
      headers: {
        Authorization: AUTH_CLIENT_AUTHORIZATION,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      timeout: 3 * 60 * 1000,
      validateStatus: (status: number) => status === 200 || status === 401,
      isNotToken: true,
      skip401Redirect: true,
    });
  },
  // 登陆后获得用户信息
  getPrincipal() {
    return request.get('/auth/account/principal');
  },
  // 通过手机号获取短信验证码
  getSmsCode(mobile: string) {
    return request.get(`/auth/sms/login?mobile=${mobile}`);
  },
  // 登陆后获得用户的动态路由
  getUserRouterByUserId(userId: string) {
    return request.get(`/system/menus/router/${userId}`);
  },
  // 通过token注销令牌
  revokeToken(token: string) {
    return request.delete(`/auth/oauth/token?token=${token}`, {
      headers: { Authorization: AUTH_CLIENT_AUTHORIZATION },
    });
  },
  // 通过userId注销令牌
  revokeId(userId: string) {
    return request.delete(`/auth/token/kick-out?userId=${userId}`);
  },
  // 删除用户
  deleteUser(userId: string, currHour: any) {
    return request.delete(`/auth/cms/user/${userId}/cancel?currHour=${currHour}`);
  },
};

export default authApi;
